import { SEMESTERS, STUDY_ITEMS_SORT } from "@/common/define";

export default {

  data() {
    return {
      ysColors: {},
      ysLegends: []
    }
  },
  methods: {
    dataColor(index) {
      let colors = [
        'rgba(61,91,150,0.5)',
        'rgba(248,121,121,0.5)',
        'rgba(180,172,77,0.5)'
      ];
      if (index > colors.length - 1) {
        let r = Math.floor(Math.random() * 255);
        let g = Math.floor(Math.random() * 255);
        let b = Math.floor(Math.random() * 255);
        return `rgba(${r}, ${g}, ${b}, 0.5)`;
      } else {
        return colors[index];
      }
    },
    mappingYsLegendColors(data, addAvg) {
      this.ysColors = {};
      this.ysLegends = [];
      if (data) {
        let list = [];
        Object.values(data).forEach((item) => {
          Object.keys(item).forEach((ys) => {
            if (ys !== 'total' && ys != 'avg' && !list.includes(ys)) {
              list.push(ys);
            }
          });
        });
        if (list.length > 0) {
          list.forEach((ys, i) => {
            this.ysColors[ys] = this.dataColor(i);
          });
          Object.entries(this.ysColors).forEach((row) => {
            let v = row[0].split('-');
            this.ysLegends.push({
              label: `${v[0]}년도 ${SEMESTERS[v[1]]}`,
              style: `background-color:${row[1]}`
            });
          });
          if (addAvg) {
            this.ysColors['avg'] = this.dataColor(list.length);
            this.ysLegends.push({
              label: '학습자평균',
              style: `background-color:${this.ysColors['avg']}`
            });
          }
        }
      }
    },
    sortData(data) {
      data.sort((a, b) => {
        return STUDY_ITEMS_SORT[a.title] - STUDY_ITEMS_SORT[b.title];
      });
    }
  }
}
